import { createFileRoute, redirect } from "@tanstack/react-router";
import { notify } from "shared/utils/notify";
import z from "zod";

/** @public */
export const Route = createFileRoute("/")({
    validateSearch: z.object({ keycloaklogin: z.number().optional() }),
    beforeLoad: async ({ context, search }) => {
        const auth = await context.auth;
        if (search.keycloaklogin == 1) {
            await auth.signinRedirect().catch(notify.catch);
            return;
        }

        if (auth.isAuthenticated) {
            throw redirect({
                to: "/messages",
            });
        }

        throw redirect({
            to: "/login",
        });
    },
});
